module.exports = __webpack_public_path__ + "static/media/_abkhazia.c6427842.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_abkhazia.svg
// module id = 2298
// module chunks = 7